export * from './student.model';
export * from './student-popup.service';
export * from './student.service';
export * from './student-dialog.component';
export * from './student-delete-dialog.component';
export * from './student-detail.component';
export * from './student.component';
export * from './student.route';
export * from './student.typeahead.service';
export * from './student.util.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/index.ts